export enum AppStepRoutes {
    PERSONAL_DETAILS = 'personal-details',
    PRODUCT_SELECTION = 'product-selection',
    APPLICATION_INFORMATION = 'application-information',
    SUMMARY = 'summary',
    PAYMENT = 'payment',
    SUBMISSION = 'submission',
}

export enum PersonalDetailsRoutes {
    PERSONAL_INFORMATION = 'personal-information',
    // IAPP2-1741: Finance Information substep removed (all fields removed)
    // FINANCE_INFORMATION = 'finance-information',
    RESIDENTIAL_INFORMATION = 'residential-information',
    MAILING_ADDRESS = 'mailing-address',
    CONTACT_INFORMATION = 'contact-information',
    RESIDENCY_AND_IDENTIFICATION = 'residency-and-identification',
    IDENTITY_VERIFICATION_CONSENT = 'identity-verification-consent',
}

export enum ProductSelectionRoutes {
    INTRO = '',
    PRODUCT_SELECTION = 'select',
}

export enum ApplicationInformationRoutes {
    OWNER = 'owner',
    BENEFICIARY = 'beneficiary',
    EXISTING_INSURANCE = 'existing-insurance',
    EXISTING_INSURANCE_REPLACEMENT = 'existing-insurance-replacement',
    STATEMENTS_AND_AGREEMENTS = 'statements-and-agreements',
}

export enum SummaryRoutes {
    SUMMARY = '',
}

export enum PaymentRoutes {
    INTRO = 'intro',
    PAYMENT_INFORMATION = 'payment-information',
    PRIMARY_PAYMENT_METHOD = 'primary-payment-method',
    SECONDARY_PAYMENT_METHOD = 'secondary-payment-method',
    ACH_DISCLAIMER = 'ach-disclaimer',
}

export enum SubmissionRoutes {
    FINAL_CONSENTS = 'final-consents',
    SUBMIT = 'submit',
}
